module.exports = __webpack_public_path__ + "static/media/logout.b35bd93b.svg";